import { render, staticRenderFns } from "./BudgetProject.vue?vue&type=template&id=3a5d125e&scoped=true"
import script from "./BudgetProject.vue?vue&type=script&lang=js"
export * from "./BudgetProject.vue?vue&type=script&lang=js"
import style0 from "./BudgetProject.vue?vue&type=style&index=0&id=3a5d125e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a5d125e",
  null
  
)

export default component.exports